<template>
  <div>
    <div v-if="!storeState.gotBlock" class="tw-flex tw-justify-center">
      <div class="tw-pt-32">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="8"
          color="primary"
        >
        </v-progress-circular>
      </div>
    </div>
    <template v-else-if="storeState.noAccess">
      <div class="no-access">
        <h4> You don't have access to this block 😢, contact your team admin to get it.
          <button @click="store.getHelp" class="btn-link"> Click here to get help.</button>
        </h4>
      </div>
      <div class="no-access">
        <h4> You can also <button @click="newBlock" class="btn-link"> create your own block here</button>
        </h4>
      </div>
    </template>
    <div v-else ref="docs">
      <!-- MAIN GRID CONTAINER -->
      <div 
        :class="{
          'tw-w-8/12': [1, 5].includes(storeState.viewNumber),
          'tw-w-screen': [2, 3].includes(storeState.viewNumber),
        }"
      >
        <span class="tw-z-10 tw-absolute">
          <v-tooltip bottom dark color="#333">
            <template v-slot:activator="{ on }">
              <button @click="backToBlocks" v-on="on" class="tw-outline-none">
                <v-icon>mdi-chevron-left</v-icon>
              </button>
            </template>
            <span class="tooltip-text">Back</span>
            <span class="key">
              <span class="key-inner">esc</span>
            </span>
          </v-tooltip>
        </span>
        <div
          class="tw-mt-8 tw-ml-8"
        >
          <input class="title" ref="title" v-model="storeState.block.title" placeholder="Untitled">
          <span @click="storeState.viewNumber=1" v-if="[2, 3].includes(storeState.viewNumber)" class="tw-text-gray-500 tw-cursor-pointer">
            {{getParamSummary(storeState.block.params)}}
          </span>
          <v-menu
            :offset-y="false"
            :offset-x="false"
            :open-on-hover="false"
            :min-width="500"
            :max-width="500"
            max-height="95vh"
            :close-on-content-click="false"
            v-model="addVizMenuOpen"
          >
            <template v-slot:activator="{ on }">
              <!-- <v-icon class="tw-float-right tw-mr-8 tw--mt-2" v-on="on" large>mdi-plus-circle</v-icon> -->
                <button @click="focusVizSearch" v-on="on" class="tw-mt-2 tw-mr-8 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path 
                      fill="#4A5568"
                      fill-rule="evenodd" 
                      clip-rule="evenodd" 
                      d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z"></path>
                  </svg>
                </button>
            </template>
            <div class="tw-inline-flex tw-mt-4 tw-mb-4 tw-ml-4">
              <input 
                ref="vizSearchTerm"
                class=""
                v-model="vizSearchFilters.searchTerm"
                placeholder="Search"
              >
              <div class="tw-absolute tw-right-0 tw-mr-4">
                <!-- <v-icon :ripple="false" class="tw-cursor-pointer" @click="changeVizSearchFilter('charts')">mdi-poll-box</v-icon> -->
                
                
                
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" @click="changeVizSearchFilter('forms')" class="tw-mt-2 tw-mr-2 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                      <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                        </path>
                      </svg>
                    </button>
                  </template>
                  <span class="tooltip-text">Show Forms</span>
                </v-tooltip>
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" @click="changeVizSearchFilter('stories')" class="tw-mt-2 tw-mr-2 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                      <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z">
                        </path>
                      </svg>
                    </button>
                  </template>
                  <span class="tooltip-text">Show Stories</span>
                </v-tooltip>
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" @click="changeVizSearchFilter('tables')" class="tw-mt-2 tw-mr-2 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                      <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z">
                        </path>
                      </svg>
                    </button>
                  </template>
                  <span class="tooltip-text">Show Tables</span>
                </v-tooltip>
                <v-tooltip bottom dark color="#333">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" @click="changeVizSearchFilter('charts')" class="tw-mt-2 tw-mr-2 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                      <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
                        </path>
                      </svg>
                    </button>
                  </template>
                  <span class="tooltip-text">Show Charts</span>
                </v-tooltip>
              </div>
            </div>
            <div v-if="vizSearchFilters.type === 'tables'">
              <div
                v-for="(block, index) in vizs"
                :key="index"
                @click="addViz(block)"
                class="add-chart-row clickable"
              >
                <strong>{{block.viz.title || block.title}}</strong>
                <v-data-table
                  fixed-header
                  disable-sort
                  :show-expand="false"
                  :headers="block.results.headers"
                  :items="block.results.rows"
                  :items-per-page="10"
                >
                </v-data-table>
              </div>
            </div>
            <div v-else-if="vizSearchFilters.type === 'forms'">
              <div
                v-for="(block, index) in vizs"
                :key="index"
                @click="addViz(block)"
                class="add-chart-row clickable"
              >
                <strong>{{block.title}}</strong>
                <div v-if="block.params && block.params.length > 0">
                  <div
                    v-for="(param, pi) in block.params"
                    :key="pi"
                  >
                    {{`${param.name}:${param.value}`}}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(block, index) in vizs"
                :key="index"
                @click="addViz(block)"
                class="add-chart-row clickable"
              >
                <div>
                  <strong>{{block.viz.title || block.title}}</strong>
                  <template>
                    <div v-if="block.cellType === 'story'">
                      <div v-html="block.story.htmlPreview"></div>
                    </div>
                    <div v-else class="add-chart">
                      <!-- {{block.viz.chartJsOptions}} -->
                      <line-chart 
                        v-if="block.viz.type === 'line'" 
                        :chart-data="block.viz.datacollection"
                        :options="block.viz.chartJsOptions"
                        :height="300"
                        :styles="chartStyles"
                      >
                      </line-chart>
                      <bar-chart 
                        v-else-if="block.viz.type === 'bar'" 
                        :chart-data="block.viz.datacollection" 
                        :options="block.viz.chartJsOptions"
                        :height="300"
                        :styles="chartStyles"
                      >
                      </bar-chart>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </v-menu>
          <!-- REFRESH -->
          <v-tooltip v-if="this.storeState.runningNowIds.length === 0" bottom dark color="#333">
            <template v-slot:activator="{ on }">
              <button v-on="on" @click="refreshData" class="tw-mt-2 tw-mr-6 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="#4A5568">
                  <path 
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  ></path>
                </svg>
              </button>
            </template>
            <span class="tooltip-text">Refresh blocks</span>
          </v-tooltip>
          <v-tooltip v-else bottom dark color="#333">
            <template v-slot:activator="{ on }">
              <button v-on="on" @click="cancelRefresh" class="pulse-grid tw-rounded-full tw-mt-2 tw-mr-6 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="#4A5568">
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </template>
            <span class="tooltip-text">Cancel</span>
          </v-tooltip>
          
          
          <v-tooltip bottom dark color="#333">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="tw-mr-6 tw-float-right">
                <button @click="openCmdKBlank" v-on="on" class="tw-mt-2 tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600">
                  <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="#4A5568">
                    <path 
                      d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z">
                    </path>
                  </svg>
                </button>
              </span>
            </template>
            <span class="tooltip-text">Commands</span>
            <span class="key">
              <span v-if="storeState.isMac" class="key-inner key-inner-icon">
                <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
              </span>
              <span v-else class="key-inner">
                Ctrl
              </span>
            </span>
            <span class="key">
              <span class="key-inner">K</span>
            </span>
          </v-tooltip>
        </div>
        <!-- GRIIIIIIIIIIIIIIIIIIIDGRIIIIIIIIIIIIIIIIIIIDGRIIIIIIIIIIIIIIIIIIIDGRIIIIIIIIIIIIIIIIIIIDGRIIIIIIIIIIIIIIIIIIIDGRIIIIIIIIIIIIIIIIIIID -->
        <div v-if="vizs.length === 0 && storeState.block.doc.layout.length === 0" class="grid-container">
          <div class="tw-font-medium tw-mt-8 tw-text-center">
            No blocks, <a @click="createBlock">click here to create one.</a>
          </div>
        </div>
        <div v-else-if="storeState.block.doc.layout.length === 0" class="grid-container">
          <div class="tw-font-medium tw-mt-8 tw-text-center">
            No panels, <a @click="addVizMenuOpen=true">click here to add one.</a>
          </div>
        </div>
        <div v-else class="grid-container">
          <grid-layout
            :layout.sync="storeState.block.doc.layout"
            :col-num="12"
            :row-height="30"
            :is-draggable="true"
            :is-resizable="true"
            :is-mirrored="false"
            :vertical-compact="true"
            :margin="[10, 10]"
            :use-css-transforms="true"
          >
            <grid-item v-for="panel in storeState.block.doc.layout"
              :x="panel.x"
              :y="panel.y"
              :w="panel.w"
              :h="panel.h"
              :i="panel.i"
              :key="panel.i"
            >
              <div 
                v-if="panel.type === 'tables'" 
                :class="{
                  'table-grid-inner': true,
                  'tw-overflow-scroll': true,
                  'tw-rounded': true,
                  'pulse-grid': storeState.runningNowIds.map(b => b.blockId).includes(panel.block.uuid),
                }"
              >
                <div class="viz-header-container tw-pl-4">
                  <strong>{{storeState.blocks[panel.block.uuid].title}}</strong>
                  <span v-if="storeState.runningNowIds.map(b => b.blockId).includes(panel.block.uuid)" class="tw-text-gray-500">
                    {{storeState.blocks[panel.block.uuid].currentRunTime}}
                  </span>
                  <span class="tw-float-right tw-mr-4">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn 
                          :class="{
                            'pulse-grid': Object.keys(storeState.blocks[panel.block.uuid].editables.pending).length > 0,
                          }"
                          icon v-on="on">
                          <v-icon small>
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in editVizOptions"
                          :key="index"
                          @click="item.f(panel)"
                        >
                          <v-list-item-title>
                            <span class="pl-1">{{item.title}}</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                          v-if="Object.keys(storeState.blocks[panel.block.uuid].editables.pending).length > 0"
                          @click="clearEditables(panel)"
                        >
                          <v-list-item-title>
                            <span class="pl-1">Cancel edits</span>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                          v-if="Object.keys(storeState.blocks[panel.block.uuid].editables.pending).length > 0"
                          @click="runEditableBlocks(panel)"
                        >
                          <v-list-item-title>
                            <span class="pl-1">Save edits ({{Object.keys(storeState.blocks[panel.block.uuid].editables.pending).length}})</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </span>
                </div>
                <v-data-table
                  fixed-header
                  disable-sort
                  :show-expand="false"
                  :items="storeState.blocks[panel.block.uuid].results.rows"
                  :items-per-page="10"
                  class="tw-rounded-lg"
                >
                  <template v-slot:header="props">
                    <thead class="">
                      <tr>
                        <th
                          v-for="(header, index) in storeState.blocks[panel.block.uuid].results.headers"
                          :key="index"
                          @click="changeSort(header.value, panel.block.uuid)"
                          @contextmenu.prevent="showContextMenuHeader"
                          :data-header-index="index"
                          :data-block-id="panel.block.uuid"
                          class="tw-border-none tw-font-medium tw-text-gray-600"
                          :class="{
                            'tw-cursor-pointer': Object.keys(storeState.blocks[panel.block.uuid].editables.pending).length === 0,
                          }"
                        >
                        <!-- :class="{
                              'tw-rounded-tl-lg': index === 0,
                              'tw-rounded-tr-lg': index === storeState.blocks[panel.block.uuid].results.headers.length - 1,
                            }" -->
                          <!-- <v-icon small class="header-icon">{{ storeState.iconLookUp[header.dtype] }} </v-icon> -->
                          {{ header.text }}
                        </th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                      <td 
                        class="text-left"
                        :class="{
                          'hover:tw-bg-black': storeState.blocks[panel.block.uuid].params.filter(p => p.type === 'editable').map(p => p.name).includes(header.text),
                          'hover:tw-text-white': storeState.blocks[panel.block.uuid].params.filter(p => p.type === 'editable').map(p => p.name).includes(header.text),
                          'tw-bg-green-300': storeState.blocks[panel.block.uuid].editables.pending[`${props.index}-${storeState.blocks[panel.block.uuid].results.headers[index].text}`],
                          'tw-text-green-900': storeState.blocks[panel.block.uuid].editables.pending[`${props.index}-${storeState.blocks[panel.block.uuid].results.headers[index].text}`],
                        }"
                        :key="index" 
                        v-for="(header, index) in storeState.blocks[panel.block.uuid].results.headers" 
                        :data-row-index="props.index"
                      > 
                        <div :data-row-index="props.index">
                          <a 
                            v-if="storeState.blocks[panel.block.uuid].params.filter(p => p.type === 'drill').map(p => p.name).includes(header.text)"
                            @click="drillDown(header.text, props.item)"
                          >
                            {{ props.item[header.text] }}
                          </a>
                          <input 
                            v-else-if="storeState.blocks[panel.block.uuid].params.filter(p => p.type === 'editable').map(p => p.name).includes(header.text)"
                            v-model="props.item[header.text]"
                            @change="updateEditable(panel, header.text, props.item, props.index)"
                          > 
                          <span v-else>
                            {{ props.item[header.text] }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <!-- FORMS FORM -->
              <div 
                v-else-if="panel.type === 'forms' && storeState.blocks[panel.block.uuid] && storeState.blocks[panel.block.uuid].form" 
                :class="{
                  'grid-inner': true,
                  'tw-overflow-scroll': true,
                  'tw-rounded': true,
                }"
              >
                <div>
                  <div class="">
                    <div class="md:tw-grid">
                      <div class="">
                        <div class="md:tw-grid md:tw-grid-cols-5 md:tw-gap-2">
                          <div class="md:tw-col-span-4 tw-text-lg tw-font-bold tw-leading-6">
                            {{storeState.blocks[panel.block.uuid].title}}
                          </div>
                          <span class="md:tw-col-span-1 tw-text-right">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                  <v-icon small>
                                    mdi-dots-horizontal
                                  </v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, index) in editVizOptions"
                                  :key="index"
                                  @click="item.f(panel)"
                                >
                                  <v-list-item-title>
                                    <span class="pl-1">{{item.title}}</span>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </span>
                        </div>
                        <div v-if="storeState.blocks[panel.block.uuid].form.justSubmitted" class="tw-mt-8 tw-p-4 tw-py-8 tw-text-center">
                          <div class="md:tw-col-span-1 tw-text-3xl tw-font-bold tw-leading-6 tw-inline-block">
                            <!-- Done! -->
                            <svg class="tw-h-20 tw-w-20" viewBox="0 0 20 20" fill="currentColor">
                                <path stroke="currentColor" stroke-width=".5" fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                            </svg>
                          </div>
                          <div v-if="storeState.blocks[panel.block.uuid].form && storeState.blocks[panel.block.uuid].form.approvalType.value != 'noApproval'" class="tw-mt-4 tw-text-gray-600">
                            The form is now in the approval queue. <a @click="storeState.blocks[panel.block.uuid].form.justSubmitted=false">Click here</a> to submit another.
                          </div>
                          <div v-else class="tw-font-medium tw-mt-4 tw-text-gray-600">
                            Your submission is complete. <a @click="storeState.blocks[panel.block.uuid].form.justSubmitted=false">Click here</a> to submit another.
                          </div>
                        </div>
                        <div v-else class="tw-mt-5">
                          <div class="sm:tw-overflow-hidden">
                            <div v-if="storeState.blocks[panel.block.uuid].form.lookups && !storeState.blocks[panel.block.uuid].performedLookup">
                              <div 
                                class="tw-px-4 tw-py-4 tw-bg-white"
                                v-for="(param, index) in storeState.blocks[panel.block.uuid].form.lookups"
                                :key="index"
                              >
                                <div v-if="param.type === 'select'">
                                  <div class="tw-space-y-1">
                                    <label id="listbox-label" class="tw-block tw-text-sm tw-leading-5 tw-font-medium tw-text-gray-600">
                                      {{param.name}}
                                    </label>
                                    <div class="tw-relative">
                                        <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                            <input 
                                              :ref="`param_${param.name}`" 
                                              @blur="onParamBlur(param, index)" 
                                              @focus="onParamFocus(param, index)" 
                                              @change="storeState.blocks[panel.block.uuid].form.performedLookup=false"
                                              v-model="param.value" 
                                              class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full"
                                            >
                                            <div @click="setParamValue('', param, index)" class="tw-absolute tw-cursor-pointer tw-inset-y-0 tw-items-center tw-mt-2 tw-pr-3 tw-right-0 tw-text-gray-400">
                                                <svg stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="tw-h-5 tw-w-5" stroke="currentColor" viewBox="0 0 20 20">
                                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-if="param.showSelect" class="tw-bg-white tw-mt-1 tw-overflow-y-scroll tw-rounded tw-shadow-lg tw-w-full tw-max-h-25vh">
                                            <ul tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="tw-max-h-60 tw-rounded-md tw-py-1 tw-text-base tw-leading-6 tw-shadow-xs tw-overflow-auto focus:tw-outline-none sm:tw-text-sm sm:tw-leading-5">
                                                <li 
                                                  role="option" 
                                                  v-for="(option, index2) in param.options.filter(o => String(o).toLowerCase().includes(String(param.value).toLowerCase())).slice(0, 100)" 
                                                  :key="`${option}-${index2}`" 
                                                  @click="setParamValue(option, param, index)" 
                                                  class="tw-text-gray-900 tw-cursor-pointer tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                    <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                                                    <span class="tw-font-normal tw-block tw-truncate" :class="
                                                    {'font-semibold': option === param.value, 'font-normal': option != param.value}">
                                                        {{option}}
                                                    </span>
                                                    <span v-if="option === param.value" class="tw-text-gray-600 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4">
                                                        <svg class="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </li>
                                                <li 
                                                  role="option" 
                                                  @click="refreshParamOptions(param.blockId, index)" 
                                                  class="tw-text-gray-900 tw-cursor-default tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                  Refresh options
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div v-else-if="!storeState.blocks[panel.block.uuid].form.performedLookup" class="">
                                  <label :for="`param_'${index}`" class="tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-600">
                                    {{param.name}}
                                  </label>
                                  <!-- <div class="tw-mt-1 tw-rounded">
                                    <input v-model="param.value" :ref="'param_' + param.name" :id="`param_'${index}`" class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full">
                                  </div> -->
                                  <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                      <input 
                                        v-model="param.value" 
                                        :ref="'param_' + param.name" 
                                        :id="`param_'${index}`" 
                                        class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full"
                                      >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="(storeState.blocks[panel.block.uuid].form.hasLookup && 
                                          storeState.blocks[panel.block.uuid].form.performedLookup && 
                                          storeState.blocks[panel.block.uuid].form.lookups && 
                                          storeState.blocks[panel.block.uuid].form.lookups[0].value) && 
                                          storeState.blocks[panel.block.uuid].params"
                            >
                              <div 
                                class="tw-px-4 tw-py-4 tw-bg-white"
                                v-for="(param, index) in storeState.blocks[panel.block.uuid].params.filter(p => p.type != 'lookup')"
                                :key="index"
                              >
                                <div v-if="param.type === 'select'">
                                  <div class="tw-space-y-1">
                                    <label id="listbox-label" class="tw-block tw-text-sm tw-leading-5 tw-font-medium tw-text-gray-600">
                                        {{param.name}}
                                    </label>
                                    <div class="tw-relative">
                                        <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                            <input 
                                              :ref="`param_${param.name}`" 
                                              @blur="onParamBlur(param, index)" 
                                              @focus="onParamFocus(param, index)" 
                                              v-model="param.value" 
                                              class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full"
                                            >
                                            <div @click="setParamValue('', param, index)" class="tw-absolute tw-cursor-pointer tw-inset-y-0 tw-items-center tw-mt-2 tw-pr-3 tw-right-0 tw-text-gray-400">
                                              
                                                <svg stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="tw-h-5 tw-w-5" stroke="currentColor" viewBox="0 0 20 20">
                                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-if="param.showSelect" class="tw-bg-white tw-mt-1 tw-overflow-y-scroll tw-rounded tw-shadow-lg tw-w-full tw-max-h-25vh">
                                            <ul tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="tw-max-h-60 tw-rounded-md tw-py-1 tw-text-base tw-leading-6 tw-shadow-xs tw-overflow-auto focus:tw-outline-none sm:tw-text-sm sm:tw-leading-5">
                                                <li 
                                                  role="option" 
                                                  v-for="(option, index2) in param.options.filter(o => String(o).toLowerCase().includes(String(param.value).toLowerCase())).slice(0, 100)"
                                                  :key="`${option}-${index2}`" 
                                                  @click="setParamValue(option, param, index)" 
                                                  class="tw-text-gray-900 tw-cursor-pointer tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                    <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                                                    <span class="tw-font-normal tw-block tw-truncate" :class="
                                                    {'font-semibold': option === param.value, 'font-normal': option != param.value}">
                                                        {{option}}
                                                    </span>
                                                    <span v-if="option === param.value" class="tw-text-gray-600 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4">
                                                        <svg class="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </li>
                                                <li 
                                                  role="option" 
                                                  @click="refreshParamOptions(param.blockId, index)" 
                                                  class="tw-text-gray-900 tw-cursor-default tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                  Refresh options
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div v-else class="">
                                  <label :for="`param_'${index}`" class="tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-600">
                                    {{param.name}}
                                  </label>
                                  <!-- <div class="tw-mt-1 tw-rounded">
                                    <input v-model="param.value" :ref="'param_' + param.name" :id="`param_'${index}`" class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full">
                                  </div> -->
                                  <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                      <input v-model="param.value" :ref="'param_' + param.name" :id="`param_'${index}`" class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="(!storeState.blocks[panel.block.uuid].form.hasLookup) && storeState.blocks[panel.block.uuid].params">
                              <div 
                                class="tw-px-4 tw-py-4 tw-bg-white"
                                v-for="(param, index) in storeState.blocks[panel.block.uuid].params.filter(p => p.type != 'lookup')"
                                :key="index"
                              >
                                <div v-if="param.type === 'select'">
                                  <div class="tw-space-y-1">
                                    <label id="listbox-label" class="tw-block tw-text-sm tw-leading-5 tw-font-medium tw-text-gray-600">
                                      {{param.name}}
                                    </label>
                                    <div class="tw-relative">
                                        <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                            <input 
                                              :ref="`param_${param.name}`" 
                                              @blur="onParamBlur(param, index)" 
                                              @focus="onParamFocus(param, index)" 
                                              v-model="param.value" 
                                              class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full"
                                            >
                                            <div @click="setParamValue('', param, index)" class="tw-absolute tw-cursor-pointer tw-inset-y-0 tw-items-center tw-mt-2 tw-pr-3 tw-right-0 tw-text-gray-400">
                                              
                                                <svg stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="tw-h-5 tw-w-5" stroke="currentColor" viewBox="0 0 20 20">
                                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-if="param.showSelect" class="tw-bg-white tw-mt-1 tw-overflow-y-scroll tw-rounded tw-shadow-lg tw-w-full tw-max-h-25vh">
                                            <ul tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="tw-max-h-60 tw-rounded-md tw-py-1 tw-text-base tw-leading-6 tw-shadow-xs tw-overflow-auto focus:tw-outline-none sm:tw-text-sm sm:tw-leading-5">
                                                <li 
                                                  role="option" 
                                                  v-for="(option, index2) in param.options.filter(o => String(o).toLowerCase().includes(String(param.value).toLowerCase())).slice(0, 100)" 
                                                  :key="`${option}-${index2}`" 
                                                  @click="setParamValue(option, param, index)" 
                                                  class="tw-text-gray-900 tw-cursor-pointer tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                    <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                                                    <span class="tw-font-normal tw-block tw-truncate" :class="
                                                    {'font-semibold': option === param.value, 'font-normal': option != param.value}">
                                                        {{option}}
                                                    </span>
                                                    <span v-if="option === param.value" class="tw-text-gray-600 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4">
                                                        <svg class="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                                        </svg>
                                                    </span>
                                                </li>
                                                <li 
                                                  role="option" 
                                                  @click="refreshParamOptions(param.blockId, index)" 
                                                  class="tw-text-gray-900 tw-cursor-default tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9 hover:tw-bg-gray-200"
                                                >
                                                  Refresh options
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div v-else class="">
                                  <label :for="`param_'${index}`" class="tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-600">
                                    {{param.name}} 
                                  </label>
                                  <!-- <div class="tw-mt-1 tw-rounded">
                                    <input v-model="param.value" :ref="'param_' + param.name" :id="`param_'${index}`" class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full">
                                  </div> -->
                                  <div class="tw-rounded tw-border tw-mt-1 tw-mb-2">
                                      <input v-model="param.value" :ref="'param_' + param.name" :id="`param_'${index}`" class="tw-pl-2 tw-py-2 tw-form-input tw-block tw-w-full">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="tw-px-4 tw-py-3 tw-bg-gray-100 tw-text-right sm:tw-px-6">
                              <span 
                                v-if="fromNowRunFormat(storeState.blocks[panel.block.uuid].results.meta.lastRun) === 'never'" 
                                class="tw-mt-1 tw-text-sm tw-leading-5 tw-text-gray-600 tw-float-left"
                              >
                                Never submitted
                              </span>
                              <span 
                                v-else
                                class="tw-mt-1 tw-text-sm tw-leading-5 tw-text-gray-600 tw-float-left"
                              >
                                Last submitted {{fromNowRunFormat(storeState.blocks[panel.block.uuid].results.meta.lastRun)}}
                              </span>
                              <span v-if="!storeState.runningNowIds.map(b => b.blockId).includes(panel.block.uuid)" class="tw-inline-flex tw-rounded-md tw-shadow-sm">
                                <button 
                                  v-if="storeState.blocks[panel.block.uuid].form.hasLookup && !storeState.blocks[panel.block.uuid].form.performedLookup && storeState.blocks[panel.block.uuid].form.lookups && storeState.blocks[panel.block.uuid].form.lookups[0].value" 
                                  @click="runLookUpBlock(panel.block.uuid)" 
                                  class="tw-inline-flex tw-justify-center tw-w-24 tw-py-2 tw-px-4 tw-border tw-border-transparent tw-text-sm tw-leading-5 tw-font-medium tw-rounded-md tw-text-white tw-bg-black hover:tw-bg-gray-800 focus:tw-outline-none focus:tw-border-gray-600 focus:tw-shadow-outline-gray active:tw-bg-gray-600 tw-transition tw-duration-150 tw-ease-in-out"
                                >
                                  Lookup
                                </button>
                                <button 
                                  v-if="storeState.blocks[panel.block.uuid].form.hasLookup && storeState.blocks[panel.block.uuid].form.performedLookup && storeState.blocks[panel.block.uuid].form.lookups && storeState.blocks[panel.block.uuid].form.lookups[0].value" 
                                  @click="storeState.blocks[panel.block.uuid].form.performedLookup=false" 
                                  class="tw-inline-flex tw-justify-center tw-w-24 tw-py-2 tw-px-4 tw-border tw-border-transparent tw-text-sm tw-leading-5 tw-font-medium tw-rounded-md tw-text-black tw-bg-white hover:tw-bg-gray-200 focus:tw-outline-none focus:tw-border-gray-400 focus:tw-shadow-outline-gray active:tw-bg-gray-200 tw-transition tw-duration-150 tw-ease-in-out"
                                >
                                  Lookup
                                </button>
                                <button 
                                  v-if="!storeState.blocks[panel.block.uuid].form.hasLookup || (storeState.blocks[panel.block.uuid].form.hasLookup && storeState.blocks[panel.block.uuid].form.performedLookup && storeState.blocks[panel.block.uuid].form.lookups && storeState.blocks[panel.block.uuid].form.lookups[0].value)" 
                                  @click="submitForm(panel.block.uuid)" 
                                  class="tw-inline-flex tw-justify-center tw-ml-8 tw-w-24 tw-py-2 tw-px-4 tw-border tw-border-transparent tw-text-sm tw-leading-5 tw-font-medium tw-rounded-md tw-text-white tw-bg-black hover:tw-bg-gray-800 focus:tw-outline-none focus:tw-border-gray-600 focus:tw-shadow-outline-gray active:tw-bg-gray-600 tw-transition tw-duration-150 tw-ease-in-out"
                                >
                                  Submit
                                </button>
                              </span>
                              <span v-else class="tw-inline-flex tw-justify-center tw-w-24 tw-py-2 tw-px-4 tw-text-sm tw-leading-5 tw-font-medium">
                                {{storeState.blocks[panel.block.uuid].currentRunTime}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div 
                v-else-if="panel.type === 'stories'" 
                :class="{
                  'grid-inner': true,
                  'tw-overflow-scroll': true,
                  'tw-rounded': true,
                  'pulse-grid': storeState.runningNowIds.map(b => b.blockId).includes(panel.block.uuid),
                }"
              >
                <span class="viz-header-edit">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon small>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in editVizOptions"
                        :key="index"
                        @click="item.f(panel)"
                      >
                        <v-list-item-title>
                          <span class="pl-1">{{item.title}}</span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </span>
                <div class="story-tile">
                  <div v-html="storeState.blocks[panel.block.uuid].story.htmlPreview"></div>
                </div>
              </div>
              <div 
                v-else 
                :class="{
                  'grid-inner': true,
                  'tw-overflow-scroll': true,
                  'tw-rounded': true,
                  'pulse-grid': storeState.runningNowIds.map(b => b.blockId).includes(panel.block.uuid),
                }"
              >
                <div class="viz-header-container">
                  <strong>{{storeState.blocks[panel.block.uuid].viz.title}}</strong>
                  <span class="viz-header-edit">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon small>
                            mdi-dots-horizontal
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in editVizOptions"
                          :key="index"
                          @click="item.f(panel)"
                        >
                          <v-list-item-title>
                            <span class="pl-1">{{item.title}}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </span>
                </div>
                <div class="grid-chart">
                  <line-chart 
                    v-if="storeState.blocks[panel.block.uuid].viz.type === 'line'" 
                    :chart-data="storeState.blocks[panel.block.uuid].viz.datacollection"
                    :options="storeState.blocks[panel.block.uuid].viz.chartJsOptions"
                    :height="300"
                    :styles="chartStyles"
                  >
                  </line-chart>
                  <bar-chart 
                    v-else-if="storeState.blocks[panel.block.uuid].viz.type === 'bar'" 
                    :chart-data="storeState.blocks[panel.block.uuid].viz.datacollection" 
                    :options="storeState.blocks[panel.block.uuid].viz.chartJsOptions"
                    :height="300"
                    :styles="chartStyles"
                  >
                  </bar-chart>
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </div>
      </div>
      <!-- RIGHT SIDEBAR -->
      <div
        v-if="([1, 5].includes(storeState.viewNumber)) && storeState.gotBlock"
        class="tw-bg-gray-200 tw-fixed tw-float-right tw-h-screen tw-overflow-y-scroll tw-right-0 tw-top-0 tw-w-4/12 tw-w-56 tw-px-8 tw-pt-6"
      >
        <div>
          <!-- SOURCE -->
          <div
            class=""
            @mouseover="hoverSource=true" 
            @mouseleave="hoverSource=false"
            v-if="['sql', 'sheetsAsSql', 'airtableAsSql', 'snippet'].includes(storeState.block.cellType)"
          >
            <div class="">
              <div class="">
                <v-icon small class="dest-type-icon">mdi-database</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Source</div>
              </div>
            </div>
            <div class="tw-ml-10 tw-mt-2">
              <v-autocomplete
                ref="source"
                v-model="storeState.block.source.uuid"
                :items="uniqueSources"
                placeholder="Postgres"
                item-text="name"
                item-value="block_uuid"
                auto-select-first
                single-line
                dense
                autocomplete="disabled"
                class="denser"
                @change="focusCm"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <!-- {{item.name}} -->
                    <v-list-item-title v-html="item.name">{{item}}</v-list-item-title>
                    <v-list-item-subtitle v-html="item.db_type"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:no-data>
                  <div></div>
                </template>
                <template v-slot:append-item>
                  <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="addSource">
                    Add source
                  </div>
                  <div 
                    v-if="storeState.gotSources" 
                    class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" 
                    @click="editSources"
                  >
                    Edit / remove sources
                  </div>
                </template>
              </v-autocomplete>
            </div>
          </div>
          <div
            class=""
            @mouseover="hoverSource=true" 
            @mouseleave="hoverSource=false"
            v-if="['python'].includes(storeState.block.cellType)"
          >
            <div class="">
              <div class="">
                <v-icon small class="dest-type-icon">mdi-language-python</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Source</div>
              </div>
            </div>
            <div class="tw-ml-10 tw-mt-2">
              <div style="padding-top: 4px;padding-bottom: 16px;">
                Python 3.7
              </div>
            </div>
          </div>
          <!-- DESTINATION -->
          <div
            v-if="!editDestination && (['sql', 'story', 'sheetsAsSql', 'airtableAsSql', 'python'].includes(storeState.block.cellType))" 
            no-gutters class="" 
            @mouseover="hoverDestination=true" 
            @mouseleave="hoverDestination=false"
          >
            <div class="">
              <div @click="showDestination=true" class="">
                <v-icon small class="dest-type-icon">mdi-arrow-right</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Destination</div>
                <div 
                  v-if="hoverDestination && storeState.block.destination.type === 'sheets' && storeState.block.destination.ss_id" 
                  class="tw-inline-block tw-float-right"
                >
                  <v-tooltip bottom dark color="#333">
                    <template v-slot:activator="{ on }">
                      <button 
                        @click="openSheet"
                        v-on="on" 
                        class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                        @mouseenter="actionBtns.openSheet = true"
                        @mouseleave="actionBtns.openSheet = false"
                      >
                        <v-icon :color="actionBtns.openSheet ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                      </button>
                    </template>
                    <span class="tooltip-text">Open Sheet</span>
                  </v-tooltip>
                </div>
                <div 
                  v-if="hoverDestination && 
                        storeState.block.destination.type === 'block' && 
                        storeState.block.destination.block &&
                        storeState.block.destination.block.uuid" 
                  class="tw-inline-block tw-float-right"
                >
                  <v-tooltip bottom dark color="#333">
                    <template v-slot:activator="{ on }">
                      <button 
                        @click="newWindow(storeState.block.destination.block.uuid)"
                        v-on="on" 
                        class="hover:tw-shadow-xl tw-ml-1 tw-rounded-full tw-w-10 tw-h-10 tw-outline-none"
                        @mouseenter="actionBtns.openSheet = true"
                        @mouseleave="actionBtns.openSheet = false"
                      >
                        <v-icon :color="actionBtns.openSheet ? '' : 'rgba(0, 0, 0, 0.25) !important'">mdi-open-in-new</v-icon>
                      </button>
                    </template>
                    <span class="tooltip-text">Open block</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div @click="editDestination = true" class="tw-cursor-pointer tw-inline-block tw-ml-9 tw-mt-2 tw-p-1 hover:tw-font-bold tw-rounded">
              <span class="" v-html="store.getDestinationSummary(storeState.block)"></span>
            </div>
          </div>
          <!-- TAGSSSSSSSSSSS -->
          <div v-if="showDestination" class="tw-mt-3">
            <div>
              <div class="">
                <v-icon small class="">mdi-tag</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Tags</div>
              </div>
            </div>
            <div class="tw-inline-block tw-ml-10 tw-mt-1">
              <template>
                <v-combobox
                  ref="tagCombobox"
                  v-model="storeState.block.tags"
                  :items="storeState.blockTags"
                  :menu-props="{ closeOnClick: true, closeOnContentClick: true}"
                  chips
                  label="Add tag"
                  multiple
                  single-line
                  auto-select-first
                  hide-selected
                  :rules="tagRules"
                  :search-input.sync="tagInput"
                  append-icon=''
                  dense
                  class="denser"
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected.text"
                      close
                      dense
                      close-icon="mdi-close"
                      label
                      @click:close="removeTag(item)"
                    >
                      {{ item.text }}
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No existing tags for "<strong>{{ tagInput }}</strong>" 
                          <v-btn class="create-tag" @click="createTag(tagInput)">create one?</v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </template>
            </div>
          </div>
          <div v-if="storeState.block.params && storeState.block.params.length === 0" no-gutters class="">
            <div>
              <div 
                class=""
                @mouseover="hoverParams=true" 
                @mouseleave="hoverParams=false"
              >
                <v-icon small class="">mdi-tune</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Parameters</div>
                <div 
                  v-if="hoverParams" 
                  class="tw-inline-block tw-float-right"
                >
                </div>
              </div>
            </div>
            <div @click="addParameter" class="tw-inline-block tw-ml-9 tw-mt-2 hover:tw-font-bold tw-cursor-pointer">
              <div>
                <div class="tw-p-1">
                  Add parameter
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="storeState.block.params && !editParams" no-gutters class="">
            <div>
              <div 
                class=""
                @mouseover="hoverParams=true" 
                @mouseleave="hoverParams=false"
              >
                <v-icon small class="">mdi-tune</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Parameters</div>
                <div 
                  v-if="hoverParams" 
                  class="tw-inline-block tw-float-right"
                >
                </div>
              </div>
            </div>
            <div class="tw-inline-block tw-ml-9 tw-mt-3 tw-w-full">
              <div>
                <div class="tw-pb-4"
                  v-for="(item, index) in storeState.block.params"
                  :key="index"
                >
                  <div 
                    @click="editParams=true" 
                    class="tw-cursor-pointer tw-inline-block tw-p-1 hover:tw-font-bold tw-rounded"
                  >
                    {{item.type}} -> {{item.name}} 
                    <span v-if="item.value">-> {{item.value}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div @click="addParameter" class="tw-inline-block tw-ml-9 tw-mt-2 hover:tw-font-bold tw-cursor-pointer">
              <div>
                <div class="tw-p-1">
                  Add parameter
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="storeState.block.params && editParams" no-gutters class="">
            <div>
              <div class="">
                <v-icon small class="">mdi-tune</v-icon>
                <div class="tw-font-bold tw-inline tw-ml-6">Parameters</div>
              </div>
            </div>
            <div class="tw-inline-block tw-ml-9 tw-mt-3 tw-w-full">
              <div>
                <div class="tw-pb-4"
                  v-for="(item, index) in storeState.block.params"
                  :key="index"
                >
                  <div class="tw-cursor-pointer tw-inline-block tw-pl-1 hover:tw-font-bold tw-rounded">
                    <v-select
                      :items="paramTypes.filter(p => (['sql', 'airtableAsSql', 'snippet'].includes(storeState.block.cellType) && p.dbSource) || !['sql', 'airtableAsSql', 'snippet'].includes(storeState.block.cellType))"
                      v-model="item.type"
                      item-text="label"
                      item-value="key"
                      label=""
                      required
                      placeholder="Type"
                      dense
                      class="denser"
                    >
                    <template v-slot:selection="data">
                        <div :data-type="data.item.value" class="tw-cursor-pointer">
                          <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                          <span class="tw-pl-0">{{data.item.label}}</span>
                        </div>
                      </template>
                      <template v-slot:item="data">
                        <div :data-type="data.item.value" class="tw-cursor-pointer">
                          <v-icon small>{{data.item.icon}}</v-icon>
                          <span class="tw-pl-2">{{data.item.label}}</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="tw-pl-1">
                    <v-text-field
                      v-if="item.type != 'lookup'"
                      v-model="item.name" 
                      autocomplete="off"
                      placeholder="Name"
                      :ref="'param_' + item.name"
                      hint=""
                      dense
                      class="denser"
                      >
                    </v-text-field>
                  </div>
                  <div v-if="item.type === 'lookup'" class="tw-pl-1">
                    <v-autocomplete
                      v-model="item.lookup"
                      :items="storeState.block.params.filter(p => p.name != item.name)"
                      placeholder="Lookup"
                      item-text="name"
                      item-value="name"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    > 
                      <template v-slot:no-data>
                        <v-list-item v-if="item.blockId">
                          <v-list-item-title @click="newWindow(item.blockId)">
                            Run block first, click to open
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-model="item.blockId"
                      :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                      placeholder="In Block"
                      item-text="title"
                      item-value="uuid"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="onNewParamBlock(item, index)"
                    >
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-model="item.column"
                      v-if="item.blockId"
                      :items="storeState.blocks[item.blockId].params"
                      :search-input.sync="paramColumnSearches[index]"
                      placeholder="Match to"
                      item-text="name"
                      item-value="name"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    > 
                      <template v-slot:no-data>
                        <v-list-item v-if="item.blockId">
                          <v-list-item-title @click="newWindow(item.blockId)">
                            Run block first, click to open
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div v-if="item.type === 'pivot'" class="tw-pl-1">
                    <v-select
                      :items="pivotTypes"
                      v-model="item.pivotType"
                      item-text="label"
                      item-value="key"
                      label=""
                      required
                      placeholder="Type"
                      dense
                      class="denser"
                    >
                    <template v-slot:selection="data">
                        <div :data-type="data.item.value" class="tw-cursor-pointer">
                          <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                          <span class="tw-pl-0">{{data.item.label}}</span>
                        </div>
                      </template>
                      <template v-slot:item="data">
                        <div :data-type="data.item.value" class="tw-cursor-pointer">
                          <v-icon small>{{data.item.icon}}</v-icon>
                          <span class="tw-pl-2">{{data.item.label}}</span>
                        </div>
                      </template>
                    </v-select>
                    <v-text-field
                      v-model="item.value" 
                      autocomplete="off"
                      placeholder="Name"
                      :ref="'param__value_' + item.name"
                      hint=""
                      dense
                      class="denser"
                      >
                    </v-text-field>
                  </div>
                  <div v-if="item.type === 'select'" class="tw-pl-1">
                    <v-autocomplete
                      v-model="item.blockId"
                      :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                      placeholder="Block title"
                      item-text="title"
                      item-value="uuid"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="onNewParamBlock(item, index)"
                    >
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-model="item.column"
                      v-if="item.blockId"
                      :items="getBlockHeaders(item.blockId)"
                      :search-input.sync="paramColumnSearches[index]"
                      placeholder="Column"
                      item-text="text"
                      item-value="value"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="updateSelectOptions(item, index)"
                    > 
                      <template v-slot:no-data>
                        <v-list-item v-if="item.blockId">
                          <v-list-item-title @click="newWindow(item.blockId)">
                            Run block first, click to open
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete
                      v-model="item.value"
                      v-if="item.column"
                      :items="item.options"
                      :search-input.sync="paramOptionSearches[index]"
                      placeholder="Value"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    > 
                      <template v-slot:append-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshParamOptions(item.blockId, index)" text>Refresh options</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item v-if="storeState.block.trigger.blockId">
                          <v-list-item-title @click="newWindow(storeState.block.trigger.blockId)">
                            Run block first, click to open
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div v-if="item.type === 'excel'" class="tw-pl-1">
                    <v-autocomplete
                      v-model="item.fileId"
                      :items="storeState.destinations.gdWorkbooks"
                      placeholder="Workbook"
                      item-text="name"
                      item-value="id"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshGdWorkbooks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-text-field
                      v-model="item.sheet" 
                      autocomplete="off"
                      :placeholder="`Sheet1!A1:D10`"
                      :ref="'param_' + item.name"
                      hint=""
                      :rules="[fieldRules.required]"
                      dense
                      class="denser"
                      >
                    </v-text-field>
                  </div>
                  <div v-if="item.type === 'sheets'" class="tw-pl-1">
                    <v-autocomplete
                      :ref="'param_spreadsheet_' + index"
                      v-model="item.spreadSheet"
                      :items="storeState.destinations.spreadSheets"
                      placeholder="Spreadsheet"
                      item-text="name"
                      item-value="id"
                      :rules="[fieldRules.required]"
                      required
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshSpreadSheets" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-text-field
                      :ref="'param_sheet_' + index"
                      v-model="item.sheet" 
                      autocomplete="off"
                      :placeholder="`Sheet1!A1:D10`"
                      hint=""
                      :rules="[fieldRules.required]"
                      dense
                      class="denser"
                      >
                    </v-text-field>
                    
                  </div>
                  <div v-if="item.type === 'file'" class="tw-pl-1">
                    <v-text-field
                      v-model="item.url" 
                      autocomplete="off"
                      :placeholder="'File URL'"
                      :ref="'param_url_' + item.name"
                      hint=""
                      dense
                      class="denser"
                      >
                    </v-text-field>
                  </div>
                  <div v-if="item.type === 'block'" class="tw-pl-1">
                    <v-autocomplete
                      v-model="item.blockId"
                      :items="blockList.filter(b => b.uuid != storeState.block.uuid)"
                      placeholder="Block title"
                      item-text="title"
                      item-value="uuid"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div 
                    v-if="item.type === 'block' && item.blockId && storeState.blocks[item.blockId].cellType === 'python' &&
                          storeState.blocks[item.blockId].python && storeState.blocks[item.blockId].python.dfNames"
                    class="tw-pl-1"
                  >
                    <v-autocomplete
                      v-model="item.dfName"
                      :items="storeState.blocks[item.blockId].python.dfNames"
                      placeholder="DataFrame"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="refreshBlocks" text>Refresh</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div v-if="item.type === 'value'" class="tw-pl-1">
                    <v-text-field
                      v-model="item.value" 
                      autocomplete="off"
                      :placeholder="'Value'"
                      :ref="'param_value_' + item.name"
                      hint=""
                      dense
                      class="denser"
                      >
                    </v-text-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="tw-ml-10 tw-mt-0 tw-mb-4">
              <button @click="editParams = false" class="hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
                Save
              </button>
              <button v-if="!addingLookup && storeState.block.params.length > 0 && storeState.block.params.filter(p => p.type === 'lookup').length === 0" @click="addLookup" class="tw-ml-8 hover:tw-bg-gray-300 tw-font-bold tw-p-1 tw-rounded">
                Add lookup
              </button>
            </div>
          </div>
        </div>
        <!-- END SOURCE / DEST -->
        <!-- START ERRORS (shown in red) -->
        <div class="tw-mt-8" v-if="storeState.paramError">
          {{storeState.paramError}}
        </div>
        <div class="tw-mt-8" v-if="storeState.dbError">
          <div class="tw-mt-4 tw-text-red-600 tw-font-bold">
            Query Error
          </div>
          <div class="tw-mt-4 tw-text-red-600">
            {{storeState.dbError}}
          </div>
          <div class="tw-mt-8">
            <div 
              class="tw-cursor-pointer tw-font-bold tw-inline"
              @click="googleDbError"
            >
              Google Error
            </div>
            <div 
              class="tw-cursor-pointer tw-font-bold tw-inline tw-pl-8 tw-text-gray-500"
              @click="storeState.dbError = false"
            >
              Dismiss
            </div>
          </div>
        </div>
        <div class="tw-mt-8 tw-text-red-600" v-else-if="storeState.block.cellType === 'json'">
          {{jsonParseError}}
        </div>
        <div 
          v-else-if="this.storeState.block.cellType ==='story' && this.storeState.block.story.blocks.length > 0"
          class="tw-mt-8"
        >
          <div class="tw-font-bold tw-pb-2">Blocks</div>
          <div
            v-for="(storyBlock, index) in storeState.block.story.blocks"
            :key="`${index}-${storyBlock.blockId}`"
            class="tw-cursor-pointer tw-pb-4"
            @click="newWindow(storyBlock.blockId)"
          >
            {{storeState.blocks[storyBlock.blockId] ? storeState.blocks[storyBlock.blockId].title : ''}}
          </div>

        </div>
      </div>
    </div>
    <div class="tw-w-8/12" style="padding-top: 300px;" v-if="storeState.showDebugStuff">
      {{storeState.block}}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';
import LineChart from './LineChart.js'
import BarChart from './BarChart.js'
import VueGridLayout from 'vue-grid-layout';


export default {
  mounted() {
    window.bus.$on('doneGetOneBlockFromFlask', (details) => {
      this.getBlock(details.blockId)
    })
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    })
    window.bus.$on('doneTempRun', (details) => {
      if (details.opts && details.opts.panelType === 'charts') {
        let block = this.storeState.blocks[details.blockId]
        this.makeChart(block)
      }
    })
    window.bus.$on('performedLookup', (details) => {
      this.storeState.blocks[details.blockId].form.performedLookup = true
    })
  },
  data() {
    return {
      intervals: [
        {value: 'hourly', text: 'Hourly'},
        {value: 'daily', text: 'Daily'},
        {value: 'weekly', text: 'Weekly'},
        {value: 'monthly', text: 'Monthly'},
        {value: 'fivemin', text: '5 minutes'},
        
      ],
      daysOfWeek: [
        {value: 'monday', text: 'Monday'},
        {value: 'tuesday', text: 'Tuesday'},
        {value: 'wednesday', text: 'Wednesday'},
        {value: 'thursday', text: 'Thursday'},
        {value: 'friday', text: 'Friday'},
        {value: 'saturday', text: 'Saturday'},
        {value: 'sunday', text: 'Sunday'},
      ],
      storeState: store.state,
      showDestination: true,
      editDestination: false,
      editRepeat: false,
      editRepeat: false,
      contextData: {},
      tagInput: '',
      tagRules: [
        v => false
      ],
      editingTag: false,
      editParams: false,
      hoverParams: false,
      paramColumnSearches: [],
      paramOptionSearches: [],
      paramTypes: [
        {key: 'value', label: 'Value', blockSource: true, dbSource: true},
        {key: 'sheets', label: 'Sheets', blockSource: true, dbSource: true},
        {key: 'excel', label: 'Excel', blockSource: true, dbSource: true},
        {key: 'file', label: 'CSV', blockSource: true, dbSource: false},
        {key: 'block', label: 'Block', blockSource: true, dbSource: false},
        {key: 'pivot', label: 'Pivot', blockSource: true, dbSource: true},
        {key: 'select', label: 'Select', blockSource: true, dbSource: true},
        {key: 'lookup', label: 'Lookup', blockSource: true, dbSource: true},
        // {key: 'api', label: 'API'},
      ],
      addingLookup: false,
      addingTrigger: false,
      savingSource: false,
      addingSchedule: false,
      savingSchedule: false,
      addVizMenuOpen: false,
      docOptionsOpen: false,
      chartStyles: {
        height: '300px',
        width: '100%',
        position: 'relative',
      },
      editVizOptions: [
        { title: 'View Block', icon: 'mdi-eye', f: this.goToSetExplore },
        { title: 'Refresh', icon: 'mdi-close', f: this.refreshDataOne },
        { title: 'Remove', icon: 'mdi-close', f: this.removeViz },
      ],
      vizSearchFilters: {
        type: 'charts',
        searchTerm: '',
      },
      explores: [],
      defaultLayout: {"x": 0,"y": 0,"w": 4,"h": 10,"i": 'abcdefg'},
      // layout: [
      //   {"x": 0,"y": 0,"w": 4,"h": 9,"i": 0},
      // ],
      linkColor: 'color: rgb(46, 170, 220)',
      iconLookUp: {
        number: 'mdi-numeric',
        string: 'mdi-format-text',
        date: 'mdi-calendar-blank',
        time: 'mdi-calendar-blank',
      },
      showSidebar: false,
      andOr: [
        {text: 'And', value: 'and'},
        {text: 'Or', value: 'or'},
      ],
      showFilters: false,
      queryFilters: [
        {
          andOr: false,
          field: 'team_role',
          operator: '=',
          value: '',
        },
        {
          andOr: 'and',
          field: 'email',
          operator: 'contains',
          value: '',
        },
      ],
      filterOperators: {
        number: [
          {display: '=', sql: '$field = $value', text: 'Equal to', key: 'equalTo'},
          {display: '≠', sql: '!=', text: 'Not equal to', key: 'notEqualTo'},
          {display: '≥', sql: '>=', text: 'Greater than or equal to', key: 'gte'},
          {display: '≤', sql: '<=', text: 'Less than or equal to', key: 'lte'},
          {display: '>', sql: '>', text: 'Greater than', key: 'gt'},
          {display: '<', sql: '<', text: 'Less than', key: 'lt'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'notNull'},
        ],
        string: [
          {display: 'Is', sql: '=', text: 'Is', key: 'notNull'},
          {display: 'Is Not', sql: '!=', text: 'Is not', key: 'notNull'},
          {display: 'Contains', sql: 'LIKE', text: 'Contains', key: 'contains'},
          {display: 'Does not contain', sql: 'NOT LIKE', text: 'Contains', key: 'notContain'},
          {display: 'Starts With', sql: 'LIKE', text: 'Contains', key: 'startsWith'},
          {display: 'Ends With', sql: 'LIKE', text: 'Contains', key: 'endsWith'},
          {display: 'Null', sql: 'IS NULL', text: 'Null', key: 'isNull'},
          {display: 'Not Null', sql: 'IS NOT NULL', text: 'Not Null', key: 'notNull'},
        ],
        time: [
          {display: 'Is', sql: '$field = $value', text: 'Is', key: 'exactDate'},
          {display: 'Is Within', sql: '$field >= $value', text: 'Is', key: 'dateWithin'},
        ]
      },
      // https://coolors.co/50514f-f25f5c-ffe066-247ba0-70c1b3
      defaultColorScheme: [
        {color: '#F25F5C', nickname: 'red', primary: true},
        {color: '#247BA0', nickname: 'blue', primary: true},
        {color: '#FFE066', nickname: 'yellow', primary: false},
        {color: '#70C1B3', nickname: 'green', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#fff', nickname: 'white', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
        {color: '#50514F', nickname: 'black', primary: false},
      ],
      showTable: true,
      showChart: false,
      showSql: false,
      store: store,
      searchTerm: store.state.searchTerm,
      showSuggestions: true,
      blockHoverIndex: -1,
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      searchResults: [],
      searchSuggestions: store.state.searchSuggestions,
      saved: false,
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
    LineChart,
    BarChart,
  },
  watch: {
    'storeState.tableLoading': {
      handler: function (newVal, oldVal) {
        console.log('watch tableLoading', 'newval: ', newVal, '   oldVal:', oldVal)
        this.showSuggestions = false
        // if (!newVal) {
          
        // } 
      }
    },
    'storeState.block.title': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          }
        },
        deep: false
    },
    'storeState.block.setQuery': {
      handler: function (newVal, oldVal) {
        this.showSuggestions = true
      }
    },
    'storeState.block.tags': {
        handler: function (val, oldVal) {
          console.log('storeState.block.tags: ', val, oldVal)
          var tags = []
          for (let [key, value] of Object.entries(this.storeState.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            let allTagKeys = tags.map(t => t.value)
            let newTags = _.difference(blockTagKeys, allTagKeys)
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                tags.push(value.tags.find(t => t.value === newTags[i]))
              }
            }
          }
          this.storeState.blockTags = tags
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          console.log('this.storeState.blockTags: ', this.storeState.blockTags)
        },
        deep: true,
    },
    'storeState.block.code': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.setQueryFilters': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.destination': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.source': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.repeat': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
    'storeState.block.favorite': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.params': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        }
    },
    'storeState.block.doc.layout': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
        },
        deep: true
    },
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    removeTag(item) {
      this.storeState.block.tags.splice(this.storeState.block.tags.indexOf(item), 1)
      this.storeState.block.tags = [...this.storeState.block.tags]
    },
    newWindow(blockId) {
      console.log('newWindow: ', blockId)
      this.storeState.blockListOpen = false
      this.blockHistoryHover = -1
      if (!blockId) {
        blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        store.saveToLocalStorage('seekwell_newBlockId', blockId)
      }
      let routeData = this.$router.resolve({ name: 'Run', params: {id:  blockId}});
      window.open(routeData.href, '_blank');
      this.storeState.cmdkActive = false
    },
    onNewParamBlock(param, index) {
      this.paramColumnSearches[index] = ''
      // param.value = ''
      // param.column = 'blah'
      // Vue.set(this.storeState.block.params, index, param)
    },
    runLookUpBlock(param, index) {
      // if (param.column && param.blockId) {
      //   this.storeState.block.params[index].options = this.storeState.blocks[param.blockId].results.rows.map(row => row[param.column])
      // }
    },
    updateSelectOptions(param, index) {
      if (param.column && param.blockId) {
        this.storeState.block.params[index].options = this.storeState.blocks[param.blockId].results.rows.map(row => row[param.column])
      }
    },
    refreshParamOptions(blockId, index) {
      let block = this.storeState.blocks[blockId]
      store.runTempBlock(block, 
        {
          rowLimit: 10000, 
          updateBlock: true, 
          updateParamOptions: {
            blockId: this.storeState.block.uuid,
            index: index,
          },
        }
      )
    },
    getBlockParams(blockId) {
      var params = []
      if (blockId && this.storeState.blocks[blockId] && this.storeState.blocks[blockId].params) {
        params = this.storeState.blocks[blockId].params.map(function(elem) {
          return {
            name: elem.name,
            value: elem.name,
          } 
        });
      }
      return params
    },
    getBlockHeaders(blockId) {
      var headers = []
      if (blockId && this.storeState.blocks[blockId] && this.storeState.blocks[blockId].results &&
          this.storeState.blocks[blockId].results.headers) {
            headers = this.storeState.blocks[blockId].results.headers
          }
      return headers
    },
    refreshBlocks() {
      this.loadingSpreadsheets = true
      this.$parent.getSoupBlocks({rowLimit: this.storeState.maxBlocksToGet})
    },
    changeSort(column, blockId) {
      if (Object.keys(this.storeState.blocks[blockId].editables.pending).length > 0) return
      let block = this.storeState.blocks[blockId]
      if (block.results.tableOptions.sortBy === column) {
        let direction = !block.results.tableOptions.sortDesc
        block.results.tableOptions.sortDesc = direction
        block.results.rows = _.orderBy(
          block.results.rows, [column], [(direction ? 'desc' : 'asc')]);
      } else {
        block.results.tableOptions.sortBy = column
        block.results.tableOptions.sortDesc = false
        block.results.rows = _.orderBy(
          block.results.rows, [column], ['asc']);
      }
    },
    showContextMenuHeader(e) {
      e.preventDefault()
      console.log('show context', e)
      this.contextOptions = [
        { title: 'Copy column name', icon: 'mdi-content-copy', f: this.copyColumnName },
        // { title: 'Filter', icon: 'mdi-filter', f: this.addFilterFromHeader },
        { title: 'Hide', icon: 'mdi-eye-off-outline', f: this.hideHeader },
        { title: 'Pivot', icon: 'mdi-subdirectory-arrow-left', f: this.showPivot },
      ]
      // if (this.storeState.block.pivot.active) {
      //   let removePivot = { title: 'Remove Pivot', icon: 'mdi-close', f: this.removePivot }
      //   this.contextOptions.push(removePivot)
      // }
      let headerIndex = e.currentTarget.dataset.headerIndex || e.target.dataset.headerIndex
      let blockId = e.currentTarget.dataset.blockId || e.target.dataset.blockId
      let header = this.storeState.blocks[blockId].results.headers[Number(headerIndex)]
      this.contextData.header = header
      this.contextData.x = e.clientX
      this.contextData.y = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    clearEditables(panel) {
      Vue.set(this.storeState.blocks[panel.block.uuid].editables, 'pending', {})
    },
    updateEditable(panel, column, row, rowNum) {
      console.log('updateEditable: ', row)
      let param = this.storeState.blocks[panel.block.uuid].params.find(p => p.type === 'editable' && column === p.name)
      var rowUpdates = {}
      let key = `${rowNum}-${column}`
      if (this.storeState.blocks[panel.block.uuid].editables.pending[key]) {
        rowUpdates = this.storeState.blocks[panel.block.uuid].editables.pending[key]
      }
      rowUpdates[key] = {row: row, param: param}
      Vue.set(this.storeState.blocks[panel.block.uuid].editables.pending, key, rowUpdates)
    },
    runEditableBlocks(panel) {
      for (let [key, obj] of Object.entries(this.storeState.blocks[panel.block.uuid].editables.pending)) {
        this.runEditableBlock(obj[key])
      }
      Vue.set(this.storeState.blocks[panel.block.uuid].editables, 'pending', {})
    },
    runEditableBlock(opts) {
      let block = store.makeBlockSafe(this.storeState.blocks[opts.param.updateWithBlock])
      for (let index = 0; index < block.params.length; index++) {
        const param = block.params[index];
        if (param.type && param.type === 'value' && param.name in opts.row) {
          param.value = opts.row[param.name]
        }
      }
      let runId = store.uuidv4()
      let sub = {
        params: block.params,
        user: this.storeState.settings.user.me.email,
        date: moment.unix(moment()).utc()._i,
        statusChanged: moment.unix(moment()).utc()._i,
        status: 'approved',
        edit: false,
        uuid: runId,
      }
      this.storeState.runningNowIds.push({runId: runId, blockId: block.uuid})
      store.runTempBlock(block, {
          runId: runId,
        }
      )
    },
    drillDown(col, row, blockId) {
      console.log('drillDown: ', col)
      let drill = this.storeState.blocks[blockId].params.find(p => p.name === col)
      if (drill.drillToBlock) {
        let drillToBlock = this.storeState.blocks[drill.drillToBlock]
        let q = { runOnLoad: 1 }
        q[drill.name] = row[col]
        if (drillToBlock.cellType === 'doc') {
          this.$router.push(
            { 
              name: 'Docs', 
              params: {id: drill.drillToBlock }, 
              query: q
            }
          ).catch(err => console.error(err))
          this.$router.go()
        } else {
          this.$router.push(
            { 
              name: 'Run', 
              params: {id: drill.drillToBlock }, 
              query: q
            }
          ).catch(err => console.error(err))
        }
        
      }
    },
    runLookUpBlock(blockId) {
      let lookup = this.storeState.blocks[blockId].params.find(p => p.type === 'lookup')
      let block = this.storeState.blocks[lookup.blockId]
      let p = block.params.find(p => p.name === lookup.lookup)
      let newP = this.storeState.blocks[blockId].form.lookups.find(p => p.name === lookup.lookup)
      p.value = newP.value
      store.runTempBlock(block, 
        {
          rowLimit: 2, 
          updateBlock: true, 
          updateFormOptions: {
            blockId: blockId,
            lookup: lookup,
          },
        }
      )
    },
    setParamsFromUrl() {
      if (this.$route.query && Object.keys(this.$route.query).length > 0 && this.storeState.block.params.length > 0) {
        for (let index = 0; index < this.storeState.block.params.length; index++) {
          const p = this.storeState.block.params[index];
          if (this.$route.query[p.name]) {
            console.log('found: ', this.$route.query[p.name])
            this.storeState.block.params[index].value = this.$route.query[p.name]
          }
        }
      }
      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.viewNumber) {
          this.storeState.viewNumber = this.$route.query.viewNumber
        }
        if (this.$route.query.runOnLoad) {
          this.refreshData()
        }
      }
    },
    createTag(tag) {
      console.log(tag)
      // this.storeState.addingTag = true
      // this.storeState.cmdkParentCmd = 'createTag'
      // this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
      let newTag = {
        value: store.uuidv4(),
        text: this.tagInput,
      }
      this.storeState.block.tags.push(newTag)
      setTimeout(() => {
        this.tagInput = ''
      }, 0);
    },
    submitForm(blockId) {
      let block = this.storeState.blocks[blockId]
      let params = block.params.map(obj => {
        let obj2 = JSON.parse(JSON.stringify(obj))
        obj2.options = []
        return obj2
      })
      for (let index = 0; index < params.length; index++) {
        const param = params[index];
        if (param.type && param.type === 'lookup') {
          //pass
        } else if ((param.default === 'required' || !('default' in param)) && (!param.value || param.value.length === 0)) {
          this.storeState.snackbar = true
          this.storeState.message = `${param.name} is required.`
          let pRef = `param_${param.name}`
          this.$refs[pRef][0].focus()
          return
        } else if ('default' in param && param.value && param.value.length === 0) {
          param.value = param.default
        }
      }
      let runId = store.uuidv4()
      let sub = {
        params: params,
        user: this.storeState.settings.user.me.email,
        date: moment.unix(moment()).utc()._i,
        statusChanged: moment.unix(moment()).utc()._i,
        status: 'pending',
        edit: false,
        uuid: runId,
      }
      if (block.form.approvalType.value === 'noApproval') {
        sub.status = 'approved'
        block.form.justSubmitted = true
        store.runTempBlock(block, {
            updateBlock: true,
            panelType: 'form',
            runId: runId,
          }
        )
        this.storeState.runningNowIds.push({runId: runId, blockId: blockId})
      } else {
        this.storeState.snackbar = true;
        this.storeState.message = `Form submitted!`;
        block.form.justSubmitted = true
      }
      block.form.submits.push(sub)
      block.form.performedLookup = false
      // this.clearForm(block)
    },
    runCode(block, opts) {
      store.runTempBlock(block, opts)
    },
    clearForm(block) {
      for (let index = 0; index < block.params.length; index++) {
        block.params[index].value = ''
      }
    },
    checkForLookupAndClean(block) {
      block.form.performedLookup = false
      block.form.justSubmitted = false
      for (let index = 0; index < block.params.length; index++) {
        const element = block.params[index];
        element.value = ''
      }
      block.form.formFields = block.params.filter(p => p.type != 'lookup')
      block.form.lookupDetails = block.params.filter(p => p.type === 'lookup')
      if (block.form.lookupDetails.length > 0) {
        block.form.lookupDetails = block.form.lookupDetails[0]
        block.form.hasLookup = true
        block.form.lookups = block.params.filter(p => p.name === block.form.lookupDetails.lookup)
        if (block.form.lookups.length > 0) {
          block.form.lookups[0].value = ''
          block.form.formFields = block.form.formFields.filter(f => f.name != block.form.lookupDetails.lookup)
        }
      }
    },
    getUserNickname(email) {
      if (email) return email.split('@')[0]
      return this.storeState.settings.user.me.email.split('@')[0]
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    getUserRole(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.role
      return ''
    },
    refreshDataOne(panel) {
      let opts = {
        updateBlock: true,
        panelType: panel.type,
      }
      const blockId = panel.block.uuid
      let block = store.makeBlockSafe(this.storeState.blocks[blockId])
      if (this.storeState.block.params.length > 0 && block.params.length > 0) { //replace block params with doc param values
        for (let i2 = 0; i2 < this.storeState.block.params.length; i2++) {
          const p = this.storeState.block.params[i2];
          for (let i3 = 0; i3 < block.params.length; i3++) {
            const p2 = block.params[i3];
            if (p2.name === p.name) {
              p2.value = p.value
            }
          }
        }
      }
      let runId = store.uuidv4()
      this.storeState.runningNowIds.push({runId: runId, blockId: blockId})
      block = store.makeBlockSafe(block)
      store.runTempBlock(block, {
          updateBlock: true,
          panelType: panel.type,
          runId: runId,
        }
      )
    },
    cancelRefresh() {
      this.storeState.canceledRunIds = this.storeState.runningNowIds
      this.storeState.runningNowIds = []
    },
    refreshData() {
      for (let index = 0; index < this.storeState.block.doc.layout.length; index++) {
        const panel = this.storeState.block.doc.layout[index]
        const blockId = panel.block.uuid
        if (panel.type != 'forms') {
          if (this.storeState.block.params.length > 0 && this.storeState.blocks[blockId].params.length > 0) { //replace block params with doc param values
            for (let i2 = 0; i2 < this.storeState.block.params.length; i2++) {
              const p = this.storeState.block.params[i2];
              for (let i3 = 0; i3 < this.storeState.blocks[blockId].params.length; i3++) {
                const p2 = this.storeState.blocks[blockId].params[i3];
                if (this.storeState.blocks[blockId].params[i3].name === p.name) {
                  this.storeState.blocks[blockId].params[i3].value = p.value
                }
              }
            }
          }
          let runId = store.uuidv4()
          this.storeState.runningNowIds.push({runId: runId, blockId: blockId})
          let block = store.makeBlockSafe(this.storeState.blocks[blockId])
          store.runTempBlock(block, {
              updateBlock: true,
              panelType: panel.type,
              runId: runId,
            }
          )
        } else { //dont run forms, but do update the params
          let block = store.makeBlockSafe(this.storeState.blocks[blockId])
          if (this.storeState.block.params.length > 0 && block.params.length > 0) { //replace block params with doc param values
            for (let i2 = 0; i2 < this.storeState.block.params.length; i2++) {
              const p = this.storeState.block.params[i2];
              for (let i3 = 0; i3 < block.params.length; i3++) {
                const p2 = block.params[i3];
                if (p2.name === p.name) {
                  p2.value = p.value
                }
              }
            }
          }
        }
      }
    },
    createBlock(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      let self = this
      setTimeout(() => {
        let c = self.$children.find(c => c.$refs.run)
        if (c.$refs.source) c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault()
    },
    addParameter() {
      let p = {name: '', value: '', type: 'value'}
      this.storeState.block.params.push(p)
      this.editParams = true
    },
    addLookup() {
      this.addingLookup = true
      // let lookup = this.storeState.block.params.filter(p => p.type === 'lookup')
      // if (lookup.length)
      this.storeState.block.params.push({
        type: 'lookup',
        name: 'lookup'
      })
    },
    focusVizSearch() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.vizSearchTerm.focus()
        }, 50);
      })
    },
    getParamSummary(params) {
      if (!params || params.length === 0) {
        return ''
      }
      let ret = ''
      for (let index = 0; index < params.length; index++) {
        const p = params[index];
        ret+= `${p.name}:${p.value} `
      }
      return ret
    },
    getRepeat(repeat) {
      var ret = false
      if (this.storeState.settings.user.me.trial_expired > 0) {
        ret = 'Trial expired, upgrade to continue scheduling'
        return ret
      } else if (repeat.period === 'hourly') {
        ret = `Hourly at ${repeat.minutesPast} minutes past`
      } else if (repeat.period === 'daily') {
        ret = `Daily at ${repeat.runTime || ' not selected'}`
      } else if (repeat.period === 'weekly') {
        ret = `Weekly on ${repeat.dayOfWeek.replace(/^\w/, c => c.toUpperCase())} at ${repeat.runTime}`
      } else if (repeat.period === 'monthly') {
        ret = `Monthly`
      } else if (repeat.period === 'fivemin') {
        ret = `Every 5 minutes`
      }
      if (this.storeState.block.trigger && this.storeState.block.trigger.blockId && ret) {
        return `${ret} (with trigger)`
      } else if (ret) {
        return ret
      }
      return `Add schedule`
    },
    openCmdKBlank() {
      this.$parent.openCmdK({})
    },
    moment: function () {
      return moment();
    },
    changeVizSearchFilter(type) {
      this.vizSearchFilters.type = type
      this.addVizMenuOpen = false
      this.addVizMenuOpen = true
    },
    editDoc() {
      this.addVizMenuOpen = true
      this.addVizMenuOpen = false
    },
    onVizSearch() {
      // this.getExplores()
    },
    makeChart(block) {
      console.log('make chart')
      let dm = this.getDimensionsMeasures(block.results.rows, block)
      if (dm.dimensions.length === 0) return
      block.viz.datacollection = {
        labels: this.getChartLabels(block.results.rows, dm),
        datasets: this.getChartData(block.results.rows, dm, block),
      }
      store.updateBlock({block: block, sliceAt: 2000})
    },
    getDimensionsMeasures(d, block) {
      let dimensions = []
      let measures = []
      if (block.setQueryThings.length === 1) {
        var allFields = this.getAllFieldsForSet(block.setQueryThings[0])
        block.setQueryThings = [...allFields, ...block.setQueryThings]
      }
      for (let i = 0; i < block.setQueryThings.length; i++) {
        let setInfo = block.setQueryThings[i]
        if (!setInfo) {
          //do nothing
        } else if (setInfo.measure) {
          console.log('found measure: ', setInfo)
          setInfo.data = []
          measures.push(setInfo)
        } else {
          dimensions.push(setInfo)
        }
      }
      return {dimensions: dimensions, measures: measures}
    },
    getChartLabels(d, dm) {
      let rows = []
      let dim = dm.dimensions.filter(o => o.selected)[0]
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        let val = row[dim.label] || row[dim.name]
        rows.push(val)
      }
      return rows
    },
    getChartData(d, dm, block) {
      let rows = []
      for (let i = 0; i < d.length; i++) {
        let row = d[i];
        // dm.measures[i].data = []
        for (let i2 = 0; i2 < dm.measures.length; i2++) {
          let val = row[dm.measures[i2].label] || row[dm.measures[i2].name]
          dm.measures[i2].data.push(val)
        }
      }
      for (let i = 0; i < dm.measures.length; i++) {
        let el = dm.measures[i];
        if (el.selected) {
          var color = this.defaultColorScheme[i].color
          if (!color) color = this.getRandomColor()
          rows.push({
            label: el.label,
            backgroundColor: color,
            borderColor: color,
            data: el.data,
            fill: block.viz.fill
          })
        }
      }
      return rows
    },
    addViz(block) {
      console.log('add viz;', block)
      this.addVizMenuOpen = false
      let tileId = store.uuidv4()
      var height = this.defaultLayout.h
      if (this.vizSearchFilters.type === 'tables') {
        height = 15
      }
      if (this.storeState.block.doc.layout.length === 0) {
        var tile = JSON.parse(JSON.stringify(this.defaultLayout))
        tile.i = tileId
      } else {
        let last = this.storeState.block.doc.layout[this.storeState.block.doc.layout.length-1]
        var tile = {"x": this.defaultLayout.x, "y": last.y+1, "w": this.defaultLayout.w, "h": this.defaultLayout.h, "i": tileId}
      }
      tile.block = {uuid: block.uuid}
      tile.type = this.vizSearchFilters.type
      tile.h = height
      this.storeState.block.doc.layout.push(tile)
    },
    removeViz(panel) {
      this.storeState.block.doc.layout = this.storeState.block.doc.layout.filter(t => t.i !== panel.i)
    },
    goToSetJson(blockId) {
      this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
    },
    goToSetExplore(panel) {
      let blockId = panel.block.uuid
      let block = this.storeState.blocks[blockId]
      if (block.cellType === 'story') {
        this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      } else {
        this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      }
      // } else {
        
      //   let routeData = this.$router.resolve({ name: 'Sets', params: {id: blockId }});
      //   window.open(routeData.href, '_blank');
      // }
    },
    editSources() {
      console.log('edit source...')
      this.$router.push({ name: 'Sources' }).catch(err => console.error(err))
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    goToSql() {
      this.$router.push({ name: 'Run', params: {id: this.storeState.block.uuid }}).catch(err => console.error(err))
    },
    addFilter() {
      let filter = {
        andOr: false,
        field: '',
        operator: '=',
        value: '',
      }
      if (this.storeState.block.setQueryFilters.length > 0) {
        filter.andOr = 'and'
      }
      this.storeState.block.setQueryFilters.push(filter)
    },
    removeFilter(index) {
      this.storeState.block.setQueryFilters.splice(index, 1)
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getTypeIcon(row) {
      if (row.measure) return 'mdi-numeric'
      if (!row.type) return 'mdi-format-text'
      return this.iconLookUp[row.type]
    },
    showTableNow() {
      this.showTable = true
      this.showChart = false
    },
    showChartNow() {
      this.showTable = false
      this.showChart = true
    },
    backToBlocks() {
      this.storeState.searching = false
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    fromNowRunFormat: function (data) {
      if (!data) return 'Never run'
      return moment(data/1000).fromNow()
    },
    fromNowFormat: function (data) {
      return moment(data.viewedOn/1000).fromNow()
    },
    clearRepeat() {
      this.editRepeat = false
      this.addingTrigger = false
      this.storeState.block.repeat = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
      this.storeState.block.trigger = JSON.parse(JSON.stringify(this.storeState.blockTemplate.repeat))
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
    },
    addTrigger() {
      this.addingTrigger = true
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    getBlock(uuid) {
      console.log('getBlock: ', uuid)
      if (uuid === 'new') {
        let blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        store.saveToLocalStorage('seekwell_newBlockId', blockId)
        let routeData = this.$router.push({ name: 'Run', params: {id:  blockId}})
      }
      this.storeState.gotBlock = false
      this.storeState.noAccess = false
      let newBlockId = store.getFromLocalStorage('seekwell_newBlockId')
      if (this.storeState.gotBlocks) {
        let block = this.storeState.blocks[uuid]
        if (block) {
          console.log('getBlock2: ', block)
          block = store.addMissingBlockAttributes(block)
          this.storeState.block = block
          if (block.destination.sheet && this.storeState.destinations.sheets.length === 0) {
            this.storeState.destinations.sheets.push(block.destination.sheet)
          }
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          } else {
            document.title = 'Untitled'
          }
          for (let index = 0; index < this.storeState.block.doc.layout.length; index++) {
            const panel = this.storeState.block.doc.layout[index];
            this.storeState.blocks
            Vue.set(this.storeState.blocks, panel.block.uuid, store.addMissingBlockAttributes(this.storeState.blocks[panel.block.uuid]))
            if (panel.type === 'forms') {
              if (this.storeState.blocks[panel.block.uuid]) this.checkForLookupAndClean(this.storeState.blocks[panel.block.uuid])
            }
          }
          setTimeout(() => {
            this.storeState.gotBlock = true
            this.setParamsFromUrl()
          }, 100);
        } else if (this.storeState.newBlocks.includes(uuid) || (!uuid || uuid === 'new' || uuid.length === 0)) {
          this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
          this.storeState.block.uuid = uuid
          this.storeState.block.email = this.storeState.settings.user.me.email
          document.title = 'Untitled'
          this.storeState.block.cellType = 'doc'
          this.storeState.gotBlock = true
        } else {
          // this.storeState.noAccess = true
          // console.log('you dont have access to this block')
        }
      } else if (newBlockId || this.storeState.newBlocks.includes(uuid)) {
        if (newBlockId) {
          console.log('using newBlockId...')
          localStorage.removeItem('seekwell_newBlockId')
          uuid = newBlockId
        }
        this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
        this.storeState.block.uuid = uuid
        document.title = 'Untitled'
        this.storeState.newBlocks.push(uuid)
        this.storeState.gotBlock = true
        this.storeState.gettingBlock = false
        if (this.storeState.defaultSource) {
          this.storeState.block.source = this.storeState.defaultSource
        } else {
          let localSource = store.getFromLocalStorage('seekwell_defaultSource')
          if (localSource) {
            this.storeState.allSources = store.getFromLocalStorage('seekwell_allSources')
            this.storeState.block.source = localSource
          }
        }
        this.focusCm()
      // } else if (!this.storeState.gettingBlock) {
      //   this.getOneBlockFromFlask(uuid)
      } else {
        setTimeout(() => {
            this.getBlock(uuid)
        }, 100);
      }
    },
    getBlockHistory(uuid) {
      let blockLs = Object.keys(this.storeState.blocks).map(id => this.storeState.blocks[id])
      blockLs = blockLs.sort((a, b) => a.viewOn - b.viewOn);
      this.storeState.blockHistory = blockLs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 10)
      console.log('this.storeState.blockHistory: ', this.storeState.blockHistory)
    },
    updateUnderlay(suggestion) {
      this.storeState.block.setQuery = this.storeState.block.setQuery.replace(this.storeState.searchTerm, '')
      this.storeState.block.setQuery += suggestion.path + '  '
      // let html = ''
      // html+= `<span class="term-underlay" data-uuid="${suggestion.suggestionUuid}">${suggestion.path}</span>`
      // this.underlay = html
      this.updateUnderlayKeydown()
    },
    updateUnderlayKeydown() {
      let searchTermParts = this.storeState.block.setQuery.split(/(\s+)/)
      this.storeState.searchTerm = ''
      let html = ''
      // this.storeState.block.setQueryThings = []
      let currentMatches = []
      for (let i = 0; i < searchTermParts.length; i++) {
        let term = searchTermParts[i];
        let termMatch = this.underlayTerms.find(t => t.path === term)
        if (termMatch) {
          html+= `<span class="term-underlay" data-uuid="${termMatch.suggestionUuid}">${termMatch.path}</span>`
          termMatch
          let alreadyMatched = this.storeState.block.setQueryThings.find(t => t.path === term)
          if (!alreadyMatched) {
            termMatch.selected = true
            this.storeState.block.setQueryThings.push(termMatch)
          }
          currentMatches.push(termMatch.path)
        } else {
          this.storeState.searchTerm += term
          html+= `<span class="term-underlay term-underlay-text">${term}</span>`
        }
      }
      this.storeState.block.setQueryThings = this.storeState.block.setQueryThings.filter(t => currentMatches.includes(t.path))
      this.storeState.searchTerm = this.storeState.searchTerm.replace(/\s+/g,' ').trim();
      this.underlay = html
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      let suggestion = self.storeState.searchSuggestions[e.currentTarget.dataset.index]
      if (suggestion.type === 'snippet') {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      } else {
        this.updateUnderlay(suggestion)
        let opts = {setQueryThings: this.storeState.block.setQueryThings}
        let sql = store.generateSetSql(opts)
        this.storeState.block.code = sql
        this.storeState.block.usingSet = true
        this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
        this.showSuggestions = false
        this.storeState.searchSuggestions = []
        this.$forceUpdate()
        store.runSet({})
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      console.log('newBlocks: ', this.storeState.newBlocks)
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    filterBlocks(opts) {
      var blockResults = []
      opts.searchTerm = opts.searchTerm.toLowerCase()
      for (const blockId in this.storeState.blocks) {
        let block = this.storeState.blocks[blockId]
        if (block.code.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        } else if (block.title.toLowerCase().includes(opts.searchTerm)) {
          blockResults.push(block)
        }
      }
      blockResults = blockResults.slice(0, 5)
      return blockResults.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchIn = searchIn.toLowerCase()
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * startMatch) * 1.0 / searchTermLen
      return {include: include, matches: matches, ratio: ratio}
    },
    getAllFieldsForSet(set) {
      var self = this
      var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
      let fields = []
      for (let [key, value] of Object.entries(setFields)) {
        let f = value
        f.path = `${set.name}.${key}`
        f.name = `${key}`
        f.uuid = set.block_uuid
        f.setJsonId = set.setJsonId
        f.suggestionUuid = store.uuidv4()
        f.setType = 'field'
        fields.push(f)
      }
      return fields
    },
    getSearchSuggestions(opts) {
      var self = this
      this.storeState.searchSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      this.underlayTerms = []
      self.storeState.sets = []
      for (let [key, value] of Object.entries(self.storeState.blocks)) {
        if (value.set && value.set.type === 'sql') {
          let set = {
            name: value.title,
            block_uuid: key,
            db_type: 'set',
            type: 'set',
            setJsonId: value.set.json
          }
          self.storeState.sets.push(set)
        }
      }
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let f = value
          f.path = `${set.name}.${key}`
          f.name = `${key}`
          f.uuid = set.block_uuid
          f.setJsonId = set.setJsonId
          f.suggestionUuid = store.uuidv4()
          f.setType = 'field'
          fields.push(f)
          this.underlayTerms.push(f)
        }
        let match = this.everyLetterMatch(opts.searchTerm, set.name)
        set.details = `set`
        set.title = set.name
        set.path = set.name
        set.icon = 'mdi-table'
        set.uuid = set.block_uuid
        set.ratio = match.ratio
        set.suggestionUuid = store.uuidv4()
        set.setType = 'set'
        this.underlayTerms.push(set)
        if (match.include) {
          this.storeState.searchSuggestions.push(set)
        }
      }
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = this.everyLetterMatch(opts.searchTerm, field.path)
        let matchSpace = this.everyLetterMatch(opts.searchTerm, field.label)
        if (match.include || matchSpace.include) {
          field.title = field.label || field.name
          field.details = `${field.type} in ${field.path}`
          field.ratio = match.ratio
          field.icon = this.iconLookUp[field.type]
          field.setType = 'field'
          this.storeState.searchSuggestions.push(field)
        }
      }
      this.storeState.searchSuggestions = this.storeState.searchSuggestions.sort((a, b) => b.ratio - a.ratio);
      this.updateUnderlayKeydown()
    },
    getFilterSuggestions() {
      this.filterSuggestions = []
      let numPerCategory = 3
      let sets = []
      let fields = []
      for (let i = 0; i < this.storeState.sets.length; i++) {
        let set = this.storeState.sets[i];
        let jsonValid = false
        try {
          JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
          jsonValid = true
        } catch (error) {
          jsonValid = false
        }
        if (!set.setJsonId || !jsonValid) {
          continue
        }
        var setFields = JSON.parse(this.storeState.blocks[set.setJsonId].code).fields
        for (let [key, value] of Object.entries(setFields)) {
          let f = value
          f.path = `${set.name}.${key}`
          f.name = `${key}`
          f.uuid = set.block_uuid
          f.setJsonId = set.setJsonId
          f.suggestionUuid = store.uuidv4()
          f.setType = 'field'
          fields.push(f)
        }
      }
      let fields2 = []
      for (let i2 = 0; i2 < fields.length; i2++) {
        let field = fields[i2];
        let match = {include: true, ratio: 1}
        if (match.include && !field.measure) {
          field.title = field.label || field.name
          field.details = `${field.type} in ${field.path}`
          field.ratio = match.ratio
          field.icon = this.iconLookUp[field.type]
          field.setType = 'field'
          this.filterSuggestions.push(field)
        }
      }
      this.filterSuggestions = this.filterSuggestions.sort((a, b) => b.ratio - a.ratio);
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13].includes(e.keyCode)) {
        // e.preventDefault() //already done in App.vue
        console.log('hit enter...')
        let suggestion = self.storeState.searchSuggestions[self.storeState.searchIndex]
        this.updateUnderlay(suggestion)
        this.updateUnderlayKeydown()
        let opts = {setQueryThings: this.storeState.block.setQueryThings}
        let sql = store.generateSetSql(opts)
        this.storeState.block.code = sql
        this.storeState.block.usingSet = true
        this.storeState.block.source.uuid = this.storeState.defaultSource.block_uuid
        this.showSuggestions = false
        this.storeState.searchSuggestions = []
        store.runSet({})
        return
      }
      let opts = {searchTerm: this.storeState.searchTerm}
      this.getSearchSuggestions(opts)
      // this.filterBlocks(opts)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  computed: {
    uniqueSources: function () {
      if (!this.storeState.block || !this.storeState.block.source) return []
      let result = []
      let uniqueNickNames = []
      if (this.storeState.block.source.uuid) {
        let curS = this.storeState.allSources.find(o => o.block_uuid === this.storeState.block.source.uuid)
        if (curS) {
          result.push(curS)
          uniqueNickNames.push(curS.name)
        }
      }
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          result.push(source)
        }
      }
      result = result.concat(this.storeState.sets)
      return result
    },
    blockList() {
      if (Object.keys(this.storeState.blocks).length === 0) return []
      let blockList = []
      for (let [key, obj] of Object.entries(this.storeState.blocks)) {
        if (obj.cellType != 'json' && obj.cellType != 'set' && obj.cellType != 'snippet') {
          if (['sql', 'sheetsAsSql', 'python'].includes(obj.cellType) && obj.code.length > 0 && obj.title.length > 0) {
            blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn})
          } else if (['doc'].includes(obj.cellType) && obj.title.length > 0) {
            blockList.push({uuid: obj.uuid, title: obj.title, viewedOn: obj.viewedOn})
          }
        }
      }
      return blockList.sort((a, b) => { return b.viewedOn - a.viewedOn;})
    },
    vizs: function () {
      let vizs = []
      for (let [key, value] of Object.entries(this.storeState.blocks)) {
        if (this.vizSearchFilters.type === 'forms' && value.title.length > 0) {
          let isForm = value.tags.filter(t => t.text === 'form').length > 0
          if (isForm) {
            let st = this.vizSearchFilters.searchTerm.toLowerCase()
            var match = (value.title && value.title.toLowerCase().includes(st))
            match = match || value.title.includes(st)
            if (st.length === 0 || match) {
              vizs.push(value)
            }
          }
        } else if (value.results && value.results.rows && value.results.rows.length > 0) {
          if (this.vizSearchFilters.type === 'charts' && value.set && value.viz && value.viz.title && value.viz.title.length > 0) {
            let st = this.vizSearchFilters.searchTerm.toLowerCase()
            var match = (value.viz.title && value.viz.title.toLowerCase().includes(st))
            match = match || value.title.includes(st)
            if (st.length === 0 || match) {
              vizs.push(value)
            }
          } else if (this.vizSearchFilters.type === 'tables' && value.set && value.set.type === 'explore' && value.title.length > 0) {
            // sets tables
            let st = this.vizSearchFilters.searchTerm.toLowerCase()
            var match = (value.title && value.title.toLowerCase().includes(st))
            match = match || value.title.includes(st)
            if (st.length === 0 || match) {
              vizs.push(value)
            }
          } else if (this.vizSearchFilters.type === 'tables' && value.title.length > 0) {
            // all other tables
            let st = this.vizSearchFilters.searchTerm.toLowerCase()
            var match = (value.title && value.title.toLowerCase().includes(st))
            match = match || value.title.includes(st)
            if (st.length === 0 || match) {
              vizs.push(value)
            }
          }
        } else if (this.vizSearchFilters.type === 'stories' && value.cellType === 'story' && value.title.length > 0) {
          let st = this.vizSearchFilters.searchTerm.toLowerCase()
          var match = (value.title && value.title.toLowerCase().includes(st))
          match = match || value.title.includes(st)
          if (st.length === 0 || match) {
            vizs.push(value)
          }
        }
      }
      return vizs.sort((a, b) => { return b.viewedOn - a.viewedOn}).slice(0, 30)
    }
  },
  created() {
    store.updateBlock = debounce(store.updateBlock, 500)
    this.getBlock(this.$route.params.id)
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}

.search-container2 {
  padding-top: 20px;
  margin-left: 40px;
  margin-bottom: 20px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
  white-space: pre;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
.search-suggestions {
  padding-top: 50px;
}
.dense-col {
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.suggestion-icons {
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: 2px;
  padding-right: 5px !important;
}
.suggest-explain {
  padding-left: 40px;
}
.suggest-title {
  padding-left: 8px;
}
.io-split-container {
  margin-top: 40px;
  /* height: 50px; */
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.split-elements {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-elements-right {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 28px;
}
.split-element {
  display: inline-block;
  padding-right: 40px;
  cursor: pointer;
  font-weight: 700;
}
.split-element-right {
  display: inline-block;
  padding-right: 40px;
  font-weight: 700;
  float: right;
}
.search-table-container {
  padding-top: 0px;
}
.fetching-msg-code {
  /* background: #F5F7FA; */
  color: #666;
  padding: 5px;
  font-family: monospace;
  display: inline;
  word-wrap: break-word;
}
.dot-pulse {
  position: relative;
  display: inline-block;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
  box-shadow: 9999px 0 0 -5px #212529;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;
}

.dot-pulse::before, .dot-pulse::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #212529;
  color: #212529;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px #212529;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px #212529;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: .5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9984px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px #212529;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 9999px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px #212529;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
  30% {
    box-shadow: 10014px 0 0 2px #212529;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px #212529;
  }
}
.dot-pulse-container {
  display: inline-block;
  margin-right: 30px;
  margin-left: 30px;
}
.v-select__selections {
  padding-left: 10px;
}
.chart-option-label {
  padding-left: 1em;
}
.sw-strong {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}
.viz-row:hover {
  background-color: #F5F7FA;
}
.row-highlight:hover {
  background-color: #F5F7FA;
}
.viz-selected {
  font-weight: bold;
}
.chart-title {
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  padding-right: 10px;
}
.filter-row {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 1em;
  padding-top: .5em;
  padding-bottom: .5em;
}
.link-color {
  color: rgb(46, 170, 220);
}
.sw-button-plain {
  background: #FFFFFF;
  border: 1px solid #CBD2D9;
  box-sizing: border-box;
  border-radius: 3px;
}
.inline {
  display: inline;
}
</style>